const FETCH_INVOICES = 'fetch_invoices';
const FETCH_INVOICES_TOTALS = 'fetch_invoices_totals';
const FETCH_INVOICE_DOCS = 'fetch_invoices_docs';
const FETCH_INVOICES_CSV = 'fetch_invoices_csv';
const DECLINE_INVOICE_DOCS = 'decline_invoices_docs';
const APPROVE_INVOICE_DOCS = 'approve_invoices_docs';
const FETCH_INVOICE = 'fetch_invoice';
const DELETE_INVOICE = 'delete_invoice';
const PERSIST_INVOICE = 'persist_invoice';
const NOTIFY_SIGNER_ON_INVOICE = 'notify_signer_on_invoice';
const SEND_INVOICE_TO_DOCUSIGN = 'send_invoice_to_docusign';
const SEND_INVOICE_TO_PARENT = 'send_invoice_to_parent';
const SAVE_INVOICE_REASON = 'save_invoice_reason';
const SAVE_INVOICE_NOTE = 'save_invoice_note';
const SEND_STATEMENT_TO_PARENT = 'send_statement_to_parent';
const CREATE_INVOICE = 'create_invoice';

const CREATE_FILES_INVOICE = 'create_files_invoice';
const DELETE_FILE_INVOICE = 'delete_file_invoice';
const FETCH_FILES_INVOICE = 'fetch_files_invoice';
const FETCH_SIGNERS_INVOICE = 'fetch_signers_invoice';
const SIGN_INVOICE_DOC = 'sign_invoice_doc';
const FETCH_INVOICES_SIMPLY = 'fetch_invoices_small';

export default {
    FETCH_INVOICES,
    FETCH_INVOICES_SIMPLY,
    FETCH_INVOICES_TOTALS,
    FETCH_INVOICE_DOCS,
    DECLINE_INVOICE_DOCS,
    APPROVE_INVOICE_DOCS,
    FETCH_INVOICES_CSV,
    FETCH_INVOICE,
    CREATE_INVOICE,
    DELETE_INVOICE,
    PERSIST_INVOICE,
    NOTIFY_SIGNER_ON_INVOICE,
    FETCH_FILES_INVOICE,
    FETCH_SIGNERS_INVOICE,
    DELETE_FILE_INVOICE,
    SIGN_INVOICE_DOC,
    CREATE_FILES_INVOICE,
    SEND_INVOICE_TO_DOCUSIGN,
    SEND_INVOICE_TO_PARENT,
    SEND_STATEMENT_TO_PARENT,
    SAVE_INVOICE_REASON,
    SAVE_INVOICE_NOTE
};
